import { Observable, map } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints";
import {
  buildParamString,
  IAPIResponse,
} from "@mindmemobile/mm-shared-global"; 
import { CreateMembershipResponseModel } from "../models/MembershipAPIResponseModels";
import { IAPICreateUpdateServiceModel, IAPIGetServiceForEditResponseModel } from "../interfaces/IAPIServiceModels";
import { IAPIProductGridResponse, IAPIProductReferenceInPurchaseResponse } from "../interfaces/IAPIProductModels";

class MembershipService {
  private httpService: HttpService;

  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  save(
    data: IAPICreateUpdateServiceModel
  ): Observable<CreateMembershipResponseModel> {
    return this.httpService
      .post<
        IAPIResponse<CreateMembershipResponseModel>
      >(url.createService, data)
      .pipe(map((result) => new CreateMembershipResponseModel(result.result)));
  }

  update(data: IAPICreateUpdateServiceModel): Observable<boolean> {
    return this.httpService
      .put<IAPIResponse<boolean>>(url.updateService, data)
      .pipe(map((result) => result.result));
  }

  getServices(
    accountId: string,
    pageNumber: number,
    pageSize: number,
    searchValue: string
  ): Observable<IAPIResponse<IAPIProductGridResponse[]>> {
    const params: string = buildParamString({
      accountId: accountId,
      pageNumber: pageNumber,
      pageSize: pageSize,
      searchValue: searchValue,
    });

    return this.httpService.get<IAPIResponse<IAPIProductGridResponse[]>>(
      url.getServices,
      params
    );
  }

  getService(
    accountId: string,
    id: string
  ): Observable<IAPIResponse<IAPIGetServiceForEditResponseModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      id: id,
    });

    return this.httpService.get<
      IAPIResponse<IAPIGetServiceForEditResponseModel>
    >(url.getService, params);
  }

  updateStatus(
    accountId: string,
    id: string,
    isActive: boolean
  ): Observable<IAPIResponse<boolean>> {
    const request = {
      accountId: accountId,
      id: id,
      isActive: isActive,
    };

    return this.httpService.put<IAPIResponse<boolean>>(
      url.serviceStatusUpdate,
      request
    );
  }

  deleteItem(accountId: string, itemId: string) {
    const request = {
      accountId: accountId,
      itemId: itemId,
    };

    return this.httpService.put<IAPIResponse<boolean>>(
      url.deleteService,
      request
    );
  }

  getServiceReferenceInPurchases(
    accountId: string,
    id: string
  ): Observable<IAPIResponse<IAPIProductReferenceInPurchaseResponse>> {
    const params: string = buildParamString({
      accountId: accountId,
      id: id,
    });

    return this.httpService.get<
      IAPIResponse<IAPIProductReferenceInPurchaseResponse>
    >(url.getServiceReferenceInPurchase, params);
  }
}

export default new MembershipService();
